import {Component, OnInit} from '@angular/core';
import {CommonService} from "../common.service";
import {Router} from "@angular/router";
import { Location } from '@angular/common';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    userInfo = {'email': "", 'password': ''};
    submitted : boolean = false;
    serverMessage = {'error':'','success':''}
    forgetemail : boolean = false;
    constructor(public commonService: CommonService, private router: Router,private location: Location) {

    }

    ngOnInit() {
        var token = localStorage.getItem('token');
        var email = localStorage.getItem('email');
        if (token) {
            this.router.navigate(['dashboard']);
        }
    }

    login(userInfo,is_valid) {
        console.log(is_valid);
        if(!is_valid){
            this.submitted = true;
            return false
        }

        let url = 'http://node.illumine.info/uu28Bu';
        this.commonService.post_data(userInfo, url).subscribe(
            response => {
                console.log(response);
                //noinspection TypeScriptUnresolvedVariable
                if (response.status == 'success') {
                    //noinspection TypeScriptUnresolvedVariable
                    localStorage.setItem('token', response.token);
                    localStorage.setItem('email', userInfo.email);
                    //noinspection TypeScriptUnresolvedFunction
                    location.reload();
                } else {
                    //noinspection TypeScriptUnresolvedVariable
                    this.serverMessage.error = response.message
                }
            }, error => {
                console.log(error);
            }
        );

    }

    reset_password(userInfo){
        if(!userInfo.email){
            console.log(userInfo.email);
            this.submitted = true;
            return false
        }
        let url = 'http://node.illumine.info/h1MpXQ';
        this.commonService.post_data(userInfo, url).subscribe(
            response => {
                console.log(response);

                //noinspection TypeScriptUnresolvedVariable
                if (response.status == 'success') {
                    this.serverMessage.error = "";
                    //noinspection TypeScriptUnresolvedVariable
                    this.serverMessage.success = response.message;
                } else {
                    this.serverMessage.success = "";
                    //noinspection TypeScriptUnresolvedVariable
                    this.serverMessage.error = response.message;

                }
            }, error => {
                console.log(error);
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/login/login.component.ts